/*
|-------------------------------------------------------------------------------
| API modules/services/index.js
|-------------------------------------------------------------------------------
| The Vuex data store for users services
*/

import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './state';

export const services = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
